module.exports = __webpack_public_path__ + "static/media/nima6_new.749735ee.png";